import { getCssVar } from "./css";

function triggerScroll() {
  setTimeout(() => {
    const scroll = window.location.hash.match(/\?scroll=(.+)/);
    if (scroll) {
      const id = `midia-${scroll[1]}`;
      const element = document.getElementById(id);
      let top = 0;
      if (element) {
        top =
          element.getBoundingClientRect().top +
          window.scrollY -
          document.querySelector(".playlist-header").offsetHeight -
          parseInt(getCssVar("--spacing"));
      } else {
        console.log(
          "triggerScroll teve que calcular a posição de um elemento virtual para efetuar o scroll"
        );
        top =
          parseInt(getCssVar("--playlist-height")) *
          window.getVideoIndexById(scroll[1]);
      }
      const scrollContainer = document.querySelector(".videos");
      if (scrollContainer) {
        console.log("triggerScroll ->", top);
        scrollContainer.scroll({
          top,
          behavior: "smooth",
        });

        if (window.midiaFoiClicada) {
          window.midiaFoiClicada();
        }
      } else {
        console.log(
          "triggerScroll foi ignorado porque o scrollContainer não foi encontrado"
        );
      }
    } else {
      console.log(
        "triggerScroll foi ignorado porque a hash não possui ?scroll=..."
      );
    }
  });
}

window.triggerScroll = triggerScroll;

export { triggerScroll };
